import { DateInput, Radio } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { memo, useCallback, useContext } from 'react';
import { NestleFormWrapperContext } from 'reactApp/sections/Nestle/FormWrapper/FormWrapper.context';
import { NESTLE_HIDE_ON_EXPORT_CLASS } from 'reactApp/sections/Nestle/FormWrapper/FormWrapper.helpers';

import commonStyles from '../PetsCard.css';

export const Date = memo(() => {
    const { formData, formErrors, setFormData, setFormErrors } = useContext(NestleFormWrapperContext);
    const { dateUnknown, date } = formData;

    const handleChange = useCallback(
        (date: Date) => {
            setFormData((prev) => ({
                ...prev,
                dateUnknown: null,
                date,
            }));

            if (formErrors.date) {
                setFormErrors((prev) => ({ ...prev, date: false }));
            }
        },
        [setFormData, formErrors.date, setFormErrors]
    );

    const handleClick = useCallback(() => {
        setFormData((prev) => ({
            ...prev,
            date: undefined,
            dateUnknown: '1',
        }));
        if (formErrors.date) {
            setFormErrors((prev) => ({ ...prev, date: false }));
        }
    }, [setFormData, formErrors.date, setFormErrors]);

    return (
        <div
            className={classNames(commonStyles.field, commonStyles.date, {
                [NESTLE_HIDE_ON_EXPORT_CLASS]: Boolean(dateUnknown),
            })}
        >
            <span className={commonStyles.label}>
                <span className={commonStyles.crossedOut}>
                    счастье
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="83"
                        height="17"
                        viewBox="0 0 83 17"
                        fill="none"
                        className={commonStyles.crossedOutIconMobile}
                    >
                        <path
                            d="M82.6069 1.83694C44.7168 4.07864 0.902859 14.7672 0.902859 14.7672"
                            stroke="currentColor"
                            strokeWidth="3"
                        />
                    </svg>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="75"
                        height="7"
                        viewBox="0 0 75 7"
                        fill="none"
                        className={commonStyles.crossedOutIcon}
                    >
                        <path d="M1 5.3048C18.7881 1.26392 58.4528 1.4272 74.8072 3.15127" stroke="currentColor" strokeWidth="2.6" />
                    </svg>
                </span>{' '}
                питомец родился
            </span>
            <div className={commonStyles.dateWrapper}>
                <DateInput
                    aria-label="питомец родился"
                    value={date}
                    disableFuture={true}
                    className={classNames(commonStyles.dateInput, {
                        [commonStyles.inputError]: formErrors.date,
                    })}
                    onChange={handleChange}
                    calendarPlacement="bottom"
                    after={false}
                />
                <Radio
                    value="1"
                    checked={dateUnknown === '1'}
                    className={classNames(commonStyles.radio, NESTLE_HIDE_ON_EXPORT_CLASS)}
                    onClick={handleClick}
                >
                    не помню дату рождения
                </Radio>
            </div>
        </div>
    );
});

Date.displayName = 'Date';
